import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Noble Mick's - Craft Beverage Company's
// "Peach Bellini Frozen Cocktail -Just add Water + Prosecco" (p_ad5q4sppdp),
// pulled from Faire's live `GET /api/product-reviews/product/{product_token}`
// endpoint (the same data source that powers the product's own PDP review
// list) — verbatim comment, real reviewer, real rating, real publish date.
export const review_nm3: FaireReviewEntity = {
  token: "review_nm3",
  type: "review",
  brandName: "Noble Mick's - Craft Beverage Company",
  brandToken: "b_kxk5df5zt5",
  productToken: "p_ad5q4sppdp",
  reviewType: "product",
  reviewerName: "Anne K.",
  reviewerLocation: "Scottsbluff, NE, United States",
  stars: 5,
  reviewText: "Peach Bellini is my favorite!!! It is soooooo delicious!!!",
  reviewDate: "Nov 24, 2025",
  meta: {
    source: "api" as const,
    importedAt: "2026-08-11T21:06:39.000Z",
    importedBy: "entity-db-cli",
  },
};
